import { useSelector } from 'react-redux'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Label from '../../atoms/display/Label'
import { CompanyConstruction } from '../../../types/Company'
import { JobSelectors } from '../../../store/job/selectors'
import { ConstructionType, IndustryType } from '../../../types/job'
import FieldView from '../../molecules/display/FieldView'

type Props = {
  constructions: CompanyConstruction[]
}

function IndustryTypeView(props: {
  industryType: IndustryType
  constructionTypeMap: { [key: string]: ConstructionType }
  constructionMap: { [key: string]: CompanyConstruction }
}) {
  const { industryType, constructionTypeMap, constructionMap } = props
  const constructionTypeIds: string[] = []
  industryType.constructionTypes.forEach((type) => {
    if (Object.keys(constructionMap).includes(type.id)) {
      constructionTypeIds.push(type.id)
    }
  })
  if (constructionTypeIds.length === 0) {
    return null
  }
  return (
    <FieldView label={industryType.name}>
      <FlexColumn>
        {constructionTypeIds.map((typeId) => (
          <FlexRow>
            <Label text={constructionTypeMap[typeId].name} />
            {constructionMap[typeId].detail && <Label text={constructionMap[typeId].detail ?? ''} />}
          </FlexRow>
        ))}
      </FlexColumn>
    </FieldView>
  )
}

export default function CompanyConstructionDetailsView({ constructions }: Props) {
  const industryTypes = useSelector(JobSelectors.industryTypes)
  const constructionTypes = useSelector(JobSelectors.constructionTypes)
  const constructionTypeMap: { [key: string]: ConstructionType } = {}
  const constructionMap: { [key: string]: CompanyConstruction } = {}
  constructionTypes.forEach((type) => {
    constructionTypeMap[type.id] = type
  })
  constructions.forEach((construction) => {
    constructionMap[construction.typeId] = construction
  })
  if (constructions.length === 0) {
    return null
  }
  return (
    <FlexColumn>
      {industryTypes.map((industryType) => (
        <IndustryTypeView
          industryType={industryType}
          constructionTypeMap={constructionTypeMap}
          constructionMap={constructionMap}
        />
      ))}
    </FlexColumn>
  )
}
